





































































































































































import { Component, Vue, Prop, Emit, Watch } from 'vue-property-decorator'
import { bytesToMegabytes } from '@/utils/common'
import { AnotacaoSolicitacao, NotaSolicitacao } from '@/types/_'
import { permissionService } from '@/services/permission.service'
import EventBus from '@/plugins/EventBus'
import Apis from '@/Apis/_'
import SingleSurgeryAnnotation from './single-surgery-annotation.vue'

@Component({
  components: {
    SingleSurgeryAnnotation,
  },
})
export default class ComponentSurgeryAnnotationsModal extends Vue {
  @Prop() visible: boolean
  @Prop() surgerySolicitationId: string

  @Emit('close')
  closeModal() {}

  @Emit('esc')
  escClick() {}

  @Emit('loadingSurgeryAnnotations')
  loadingSurgeryAnnotationsChange() {}

  show: boolean = false

  $refs: {
    contentEditable: HTMLElement
  }

  @Watch('visible')
  async onVisibilityChange(visible: boolean) {
    try {
      this.$emit('loadingSurgeryAnnotations', true)

      if (visible) {
        const APIResponseGetAnnotations = await Apis.Agendamento.SolicitacaoAnotacoesApi.getSurgeryAnnotations(this.surgerySolicitationId)

        if (APIResponseGetAnnotations.success) {
          this.rawAnnotations = APIResponseGetAnnotations.data as NotaSolicitacao[]
          this.show = visible
        } else {
          EventBus.$emit('setSnackbar', {
            show: true,
            text: APIResponseGetAnnotations.message || 'Erro ao carregar anotações da solicitação',
            icon: 'warning',
            color: '#C62828',
          })
        }
      } else {
        this.show = false
      }
    } catch (error) {
      this.show = false

      EventBus.$emit('setSnackbar', {
        show: true,
        text: 'Erro ao carregar anotações da solicitação',
        icon: 'warning',
        color: '#C62828',
      })
    } finally {
      this.$emit('loadingSurgeryAnnotations', false)
    }
  }

  close() {
    this.clearDefaultAnnotationInputData

    this.$emit('close')
  }

  esc() {
    this.clearDefaultAnnotationInputData
    this.$emit('esc')
  }

  clearDefaultAnnotationInputData() {
    this.rawAnnotations = []
    this.attachmentFileInputData = null
    this.annotationTextInputData = ''
    const contentEditableElement = this.$refs.contentEditable

    if (contentEditableElement) {
      contentEditableElement.innerHTML = ''
    }
  }

  isFileTypeWarningModalOpen = false
  isUploadRecommendationModalOpen = false
  fileUploadLimitInMegaBytes = 25

  annotationTextInputData = ''
  attachmentFileInputData: File | null = null
  rawAnnotations: NotaSolicitacao[] = []
  annotationOrder: string = 'Mais recentes'
  annotationsFilterType: 'todos' | 'comArquivo' = 'todos'

  loadingSendingSurgeryAnnotation: boolean = false

  beforeDestroy() {
    this.attachmentFileInputData = null
    this.annotationTextInputData = ''

    this.close()
  }

  get parsedAnnotations(): NotaSolicitacao[] {
    let notasFiltradas = [...this.rawAnnotations]

    // Filtro por anexos
    if (this.annotationsFilterType === 'comArquivo') {
      notasFiltradas = notasFiltradas.filter(
        nota => nota.anexos && nota.anexos.length > 0,
      )
    }

    // Ordenação
    return this.annotationOrder === 'Mais antigos'
      ? notasFiltradas.sort(
        (a, b) => new Date(a.criadaEm!).getTime() - new Date(b.criadaEm!).getTime(),
      )
      : notasFiltradas.sort(
        (a, b) => new Date(b.criadaEm!).getTime() - new Date(a.criadaEm!).getTime(),
      )
  }

  deleteFileUpload() {
    this.attachmentFileInputData = null
  }


  async deleteAnnotation({ surgerySolicitationId, annotationId }) {
    try {
      const APIResponseDeleteAnnotations = await Apis.Agendamento.SolicitacaoAnotacoesApi.deleteSurgeryAnnotation(surgerySolicitationId, annotationId)

      if (APIResponseDeleteAnnotations.success) {
        const APIResponseGetAnnotations = await Apis.Agendamento.SolicitacaoAnotacoesApi.getSurgeryAnnotations(this.surgerySolicitationId)

        if (APIResponseGetAnnotations.success) {
          this.rawAnnotations = APIResponseGetAnnotations.data as NotaSolicitacao[]
        }
      } else {
        EventBus.$emit('setSnackbar', {
          show: true,
          text: APIResponseDeleteAnnotations.message || 'Erro ao deletar anotação',
          icon: 'warning',
          color: '#C62828',
        })
      }
    } catch {
      EventBus.$emit('setSnackbar', {
        show: true,
        text: 'Erro ao deletar anotação',
        icon: 'warning',
        color: '#C62828',
      })
    }
  }

  async sendSurgeryAnnotation() {
    try {
      this.loadingSendingSurgeryAnnotation = true

      const surgeryAnnotationData: AnotacaoSolicitacao = {
        solicitacaoId: this.surgerySolicitationId,
        anotacao: this.annotationTextInputData,
        anexos: null,
      }

      if (this.attachmentFileInputData) {
        const attachmentFormData = new FormData()
        attachmentFormData.append('file', this.attachmentFileInputData)

        const APIResponseUploadAttachmentFile = await Apis.Agendamento.SolicitacaoAnotacoesApi.storeSurgeryAnnotationAttachment(attachmentFormData)

        if (APIResponseUploadAttachmentFile.success) {
          surgeryAnnotationData.anexos = [{
            ...APIResponseUploadAttachmentFile.data,
            uri: APIResponseUploadAttachmentFile.data.url,
          }]
        } else {
          EventBus.$emit('setSnackbar', {
            show: true,
            text: APIResponseUploadAttachmentFile.message || 'Houve um erro ao anexar o arquivo da anotação',
            icon: 'warning',
            color: '#C62828',
          })

          return
        }
      }

      const APIResponseSaveAnnottation = await Apis.Agendamento.SolicitacaoAnotacoesApi.storeSurgeryAnnotation(surgeryAnnotationData)

      if (APIResponseSaveAnnottation.success) {
        EventBus.$emit('setSnackbar', {
          show: true,
          text: 'Anotação enviada com sucesso',
          icon: 'done',
          color: '#2E7D32',
        })

        this.attachmentFileInputData = null
        this.annotationTextInputData = ''
        const contentEditableElement = this.$refs.contentEditable as HTMLElement
        contentEditableElement.innerHTML = ''


        const APIResponseGetAnnotations = await Apis.Agendamento.SolicitacaoAnotacoesApi.getSurgeryAnnotations(this.surgerySolicitationId)

        if (APIResponseGetAnnotations.success) {
          this.rawAnnotations = APIResponseGetAnnotations.data as NotaSolicitacao[]
        } else {
          EventBus.$emit('setSnackbar', {
            show: true,
            text: APIResponseGetAnnotations.message || 'Erro ao carregar anotações da solicitação',
            icon: 'warning',
            color: '#C62828',
          })
        }
      } else {
        EventBus.$emit('setSnackbar', {
          show: true,
          text: APIResponseSaveAnnottation.message || 'Houve um erro ao enviar a anotação',
          icon: 'warning',
          color: '#C62828',
        })
      }
    } catch (error) {
      EventBus.$emit('setSnackbar', {
        show: true,
        text: 'Houve um erro ao processar anotação',
        icon: 'warning',
        color: '#C62828',
      })
    } finally {
      this.loadingSendingSurgeryAnnotation = false
    }
  }

  async uploadAttachmentFile(attachmentUploadData: any) {
    try {
      if (!attachmentUploadData) {
        return
      }

      if (this.attachmentFileInputData) {
        EventBus.$emit('setSnackbar', { show: true, text: 'Já existe um arquivo carregado', icon: 'warning', color: '#C62828' })
        return
      }

      const fileType: string = attachmentUploadData.type

      if (fileType !== 'application/pdf' && !fileType.match(/(^image)(\/)[a-zA-Z0-9_]*/gm)) {
        this.openFileTypeWarningModal(500)
        return
      }

      const fileSizeInMegabytes = bytesToMegabytes(attachmentUploadData.file.size)
      if (fileSizeInMegabytes > this.fileUploadLimitInMegaBytes) {
        this.openUploadRecommendationModal(500)
        return
      }

      this.attachmentFileInputData = attachmentUploadData.file
    } catch (error) {
      EventBus.$emit('setSnackbar', { show: true, text: 'Erro ao carregar arquivo', icon: 'warning', color: '#C62828' })
    }
  }

  openFileTypeWarningModal(delay = 0) {
    setTimeout(() => {
      this.isFileTypeWarningModalOpen = true
    }, delay)
  }

  closeFileTypeWarningModal() {
    this.isFileTypeWarningModalOpen = false
  }

  openUploadRecommendationModal(delay = 0) {
    setTimeout(() => {
      this.isUploadRecommendationModalOpen = true
    }, delay)
  }

  closeUploadRecommendationModal() {
    this.isUploadRecommendationModalOpen = false
  }

  onKeydownEnterAnnotationTextInput(e: Event) {
    e.preventDefault()
    if (this.annotationTextInputData.length >= 5) {
      this.sendSurgeryAnnotation()
    }
  }

  onKeydownAnnotationTextInput(event: KeyboardEvent) {
    const isControl = event.ctrlKey || event.metaKey
    const allowedKeys = [
      'Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown',
      'Home', 'End', 'Tab', 'Shift', 'Control', 'Meta', 'Alt',
      'Enter', 'Escape', 'PageUp', 'PageDown', 'Insert', 'ContextMenu',
    ]
    const reachedCharLimit = this.annotationTextInputData.length >= 400

    if (reachedCharLimit && !allowedKeys.includes(event.key) && !isControl) {
      event.preventDefault()
    }
  }

  onPasteAnnotationTextInputData(event: ClipboardEvent) {
    event.preventDefault()

    const pastedText = (event.clipboardData && event.clipboardData.getData('text')) || ''

    const currentText = this.annotationTextInputData
    const maxLength = 400

    const availableLength = maxLength - currentText.length
    if (availableLength <= 0) {
      return
    }

    const trimmedText = pastedText.substring(0, availableLength)
    const newText = currentText + trimmedText

    this.annotationTextInputData = newText
    const contentEditableElement = this.$refs.contentEditable as HTMLElement | undefined
    if (contentEditableElement) {
      contentEditableElement.innerText = newText
    }
  }

  get userHasWritingAnnotationPermission() {
    return permissionService.hasPermission('agendamento.medica.anotacoes.editar')
  }
}
